<template>
    <div>

        <div v-if="invite && invite.inviteKey" class="uk-margin-bottom uk-text-center">
            <div v-if="invite.valid" class="uk-text-primary">Once registered you will be linked to <span v-if="!invite.name">an account</span><strong v-if="invite.name">{{ invite.name }}</strong>.</div>
            <div v-if="!invite.valid" class="uk-text-danger">Invitation Not Found. Your account invitation has expired.</div>
        </div>

        <div class="account-setup-steps">

            <div class="item"
                 :class="{ 'current': step === 'connection', 'success': step === 'reminder' || step === 'account' || step === 'complete' }">
                <div class="step uk-text-small">Step 1</div>
                <h4 class="title uk-margin-remove">Integration</h4>

                <span class="status" v-if="step === 'connection'"><span><font-awesome-icon :icon="['far', 'alarm-clock']" /></span></span>
                <span class="status" v-if="step === 'reminder' || step === 'account' || step === 'complete'"><span><font-awesome-icon :icon="['fas', 'check']" /></span></span>
            </div>

            <div v-if="canShowReminders()"
                 class="item"
                 :class="{ 'current': step === 'reminder', 'success': step === 'account' || step === 'complete' }">
                <div class="step uk-text-small">Step 2</div>
                <h4 class="title uk-margin-remove">Reminder</h4>

                <span class="status" v-if="step === 'reminder'"><span><font-awesome-icon :icon="['far', 'alarm-clock']" /></span></span>
                <span class="status" v-if="step === 'account' || step === 'complete'"><span><font-awesome-icon :icon="['fas', 'check']" /></span></span>
            </div>

            <div class="item"
                 :class="{ 'current': step === 'account', 'success': step === 'complete' }">
                <div class="step uk-text-small">Step {{ canShowReminders() ? '3' : '2' }}</div>
                <h4 class="title uk-margin-remove">Account</h4>

                <span class="status" v-if="step === 'account'"><span><font-awesome-icon :icon="['far', 'alarm-clock']" /></span></span>
                <span class="status" v-if="step === 'complete'"><span><font-awesome-icon :icon="['fas', 'check']" /></span></span>
            </div>

        </div>
    </div>
</template>


<script>
    import {mapGetters} from "vuex";
    import { showReminders } from "../../helpers";

    export default {

        props: [
            'step'
        ],

        computed: {

            ...mapGetters({
                invite: 'registration/invite',
            }),

        },

        methods: {

            canShowReminders() {
                return showReminders(this.invite);
            }

        }
    }
</script>
